<div class="attack-simulations">
  <app-simulations-list />
</div>
